import angular from 'angular'

import '../../core/main/controller/environment'
import '../../core/main/factory/country'
import '../../core/main/filter/country/filter'
import '../../main/factory/authentication'
import '../../main/factory/okta'
import '../../core/main/directive/email_address/directive'
import '../../core/main/directive/mailcheck/directive'
import '../../core/main/factory/analytics'
import './style.scss'
import i18n from 'i18next'
document.write(require('./view.html').default)

angular.module('merchant.application.page.login', ['jm.i18next', 'merchant.application.module.languageSelector'])
  .controller('merchant.application.page.login.controller', [
    '$rootScope', '$scope', '$controller', '$location', '$window',
    'merchant.application.main.factory.authentication',
    'core.application.main.controller.environment',
    'core.application.main.factory.country',
    'merchant.application.main.factory.okta',
    'core.application.main.factory.feature',
    'core.application.main.factory.analytics',
    function ($rootScope, $scope, $controller, $location, $window, Authentication, Environment, Country, Okta, Feature, Analytics) {
      Feature.retrieveFeatureFlagPromise('merchant-portal-translations-enabled', false)
        .then(function (value) {
          $scope.translationsEnabled = value
          $scope.$apply()
        })

      Feature.retrieveFeatureFlagPromise('merchant-portal-language-selector-enabled', false)
        .then(function (value) {
          $scope.langSelectorEnabled = value
          getSelectedLanguage()
          $scope.$apply()
        })

      $controller('merchant.application.page.controller', { $scope: $scope })
      $scope.model.fatalError = false
      $scope.model.login = {
        showLanguageDialog: false,
        isRedirecting: false,
        invalidLogin: false,
        submitted: false,
        locked: false,
        countries: null,
        countryCode: null,
        credentials: {
          username: null,
          password: null
        },
        selectedCountry: {
          value: null
        }
      }
      $scope.model.sso = {
        isSSOUser: false,
        enabled: false,
        error: null
      }

      const checkIfSSOEnabled = function () {
        Okta.isFeatureEnabled().then((value) => {
          $scope.model.sso.enabled = value
          $scope.model.sso.error = Okta.loginError()
        })
      }

      $scope.isSSOLoginFlow = function (callback) {
        if (!$scope.model.sso.enabled) {
          callback(false)
          return
        }
        Okta.isEnabledForSSOLoginFlow($scope.model.login.credentials.username)
          .then((isSSO) => {
            callback(isSSO)
          }).catch(() => {
            callback(false)
          })
      }

      $scope.usernameSSOAutoLogin = () => {
        $scope.isSSOLoginFlow((isSSO) => {
          $scope.model.sso.isSSOUser = isSSO
          if (isSSO) {
            $scope.ssoLogin()
          }
        })
      }

      $scope.login = () => {
        $scope.resetSSOError()

        $scope.isSSOLoginFlow((isSSO) => {
          $scope.model.sso.isSSOUser = isSSO
          if (isSSO) {
            $scope.ssoLogin()
          } else {
            $scope.passwordLogin()
          }
        })
      }

      $scope.ssoLogin = function () {
        Okta.login(
          $scope.model.login.credentials.username,
          $window.location.origin + '/' + $scope.model.login.countryCode.toLowerCase() + '/merchant/ssoRedirect'
        )
      }

      $scope.passwordLogin = function () {
        $scope.model.login.submitted = true
        if ($scope.form.$valid) {
          Authentication.login($scope.model.login.credentials, function (success, outcome) {
            $scope.model.login.credentials.password = ''
            if (!success) {
              if (outcome && outcome.errorCode === 'account_locked') {
                $scope.model.login.locked = true
              } else if (outcome && outcome.errorCode === 'authentication_failure') {
                $scope.model.login.invalidLogin = true
              } else {
                $scope.model.fatalError = true
              }
            }
          })
        } else {
          $scope.model.login.invalidLogin = true
        }
      }

      $scope.resetSSOError = function () {
        Okta.loginError(null)
        $scope.model.sso.error = null
      }

      $scope.loggedIn = function () {
        return Authentication.loggedIn()
      }

      $scope.sendAmplitudeEvent = Analytics.sendAmplitudeEvent

      $scope.forgotLink = function () {
        let link = 'reset-ask'
        if ($scope.model.login.credentials.username) {
          // add the user's email address to the link so that it can
          // be prepopulated on the reset-ask page
          link += '?e=' + $window.encodeURIComponent($scope.model.login.credentials.username)
        }
        return link
      }

      $scope.consumerPortalLoginPageLink = function () {
        let redirectCountryCode = Country.getCountryCodeFromUrl()
        if (redirectCountryCode === 'GB') {
          // The GB country code needs to be converted to UK
          // because that's what is used in the url paths.
          redirectCountryCode = 'UK'
        }
        return (
          Environment.CONSUMER_BASE_URL +
                '/' +
                redirectCountryCode.toLowerCase()
        )
      }

      $scope.setDefaultCountry = function () {
        let ii
        $scope.model.login.countryCode = Country.getCountryCodeFromUrl()
        if ($scope.model.login.countryCode && $scope.model.login.countries && $scope.model.login.countries.length) {
          // set the default selected country based on the given country code
          for (ii = 0; ii < $scope.model.login.countries.length; ii++) {
            if ($scope.model.login.countries[ii].countryCode === $scope.model.login.countryCode) {
              $scope.model.login.selectedCountry.value = $scope.model.login.countries[ii]
            }
          }
        }
      }

      $scope.redirectToSelectedCountry = function () {
        let ii
        let redirectUrl = '' // fallback to an internal domain redirection if we can't retrieve the portalUrl
        let selectedCountryCode = (
          $scope.model.login.selectedCountry &&
                $scope.model.login.selectedCountry.value &&
                $scope.model.login.selectedCountry.value.countryCode
        )

        // PAYL-8927 Retrieve the portal url that matches the selected country code
        for (ii = 0; ii < $scope.model.login.countries.length; ii++) {
          if ($scope.model.login.countries[ii].countryCode === selectedCountryCode) {
            redirectUrl = $scope.model.login.countries[ii].portalUrl
          }
        }

        // If the user has chosen a country code that's
        // different to the country code in the url, then they were
        // probably geosteered to the wrong country url path when
        // starting the process, so we need to redirect them to the
        // right place.
        // Redirecting to a different country from this page means
        // that the user could end up in a different region which
        // has different API endpoints and settings, so we need to
        // redirect them to the right region first to get the new
        // information from those endpoints.
        if (selectedCountryCode && selectedCountryCode !== Country.getCountryCodeFromUrl()) {
          // this redirect url assumes that the path for the user
          // merchant login email page is: /{countryCode}/merchant
          // and an optional next parameter
          // Great Britain (GB) should be the United Kingdom (UK) for the redirect url
          $scope.model.login.isRedirecting = true
          selectedCountryCode = selectedCountryCode === 'GB' ? 'UK' : selectedCountryCode
          redirectUrl += '/' + selectedCountryCode.toLowerCase() + '/merchant' + $location.url()
          $window.location.href = redirectUrl
        }
      }

      const readCountries = function () {
        Country.readCountries(null, function (response) {
          $scope.model.login.countries = response.countries
          $scope.setDefaultCountry()
        })
      }

      const languages = [{ key: 'catalan', value: 'ca' }, { key: 'english', value: 'en' },
        { key: 'french', value: 'fr' }, { key: 'italian', value: 'it' }, { key: 'spanish', value: 'es' }]

      const getSelectedLanguage = function () {
        if ($scope.langSelectorEnabled) {
          const simpleLang = i18n.language.substr(
            0,
            i18n.language.indexOf('-') !== -1
              ? i18n.language.indexOf('-')
              : i18n.language.length
          )
          if (!languages.find(lang => lang.value === simpleLang)) {
            $scope.model.login.showLanguageDialog = true
          }
        } else {
          i18n.changeLanguage('en')
        }
      }

      $scope.$watch(Authentication.loggedIn, function (loggedIn) {
        if (loggedIn) {
          $location.url(decodeURIComponent($location.search().next || '/')).replace()
        }
      })

        const countriesHubUrls = {
            AU: Environment.AU_MERCHANT_HUB_URL,
            NZ: Environment.AU_MERCHANT_HUB_URL,
            US: Environment.US_MERCHANT_HUB_URL,
            CA: Environment.US_MERCHANT_HUB_URL,
            GB: Environment.EU_MERCHANT_HUB_URL,
            FR: Environment.EU_MERCHANT_HUB_URL,
            IT: Environment.EU_MERCHANT_HUB_URL,
            DE: Environment.EU_MERCHANT_HUB_URL,
            ES: Environment.EU_MERCHANT_HUB_URL,
        }

        const getHubUrl = (country) => {
            if (country === "UK") {
                return `${Environment.EU_MERCHANT_HUB_URL}/gb`
            }
          const rootUrl =  countriesHubUrls[country] || Environment.AU_MERCHANT_HUB_URL
          return `${rootUrl}/${country.toLowerCase()}`
        }

        const redirectToHub = function () {
           Feature.retrieveFeatureFlagPromise('merchant-portal-hub-redirect', false)
               .then(function (value) {
                   if (value) {
                       Authentication.verify((success) => {
                           if (!success) {
                               const redirectCountryCode = Country.getCountryCodeFromUrl().toUpperCase()
                               if (!redirectCountryCode.match(/^(IT|FR|ES|DE)$/)) {
                                   $window.location.replace(getHubUrl(redirectCountryCode))
                               }
                           }
                       })
                   }
               })
       }

      const init = function () {
        redirectToHub()
        checkIfSSOEnabled()
        readCountries()
      }

      init()
    }
  ])
